import { createApp } from 'vue'
import login from './login.vue'
import { ytPushDirective } from '@/utils/yt-push-directive'

const open = (callback?: () => void, bindToken?: string) => {
  const box = document.createElement('div')
  const Instance = createApp(login, {
    bindToken,
    onClosed: () => {
      Instance.unmount()
      box.remove()
      if (typeof callback === 'function') {
        callback()
      }
    }
  })
  // 独立 createApp 应用与主应用上下文隔离，需单独注册埋点指令
  Instance.directive('yt-push', ytPushDirective)
  document.body.appendChild(box)
  Instance.mount(box)
}

export default open
